import { render, staticRenderFns } from "./ExpandTransition.vue?vue&type=template&id=6c6de010&scoped=true"
import script from "./ExpandTransition.vue?vue&type=script&lang=js"
export * from "./ExpandTransition.vue?vue&type=script&lang=js"
import style0 from "./ExpandTransition.vue?vue&type=style&index=0&id=6c6de010&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6de010",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c6de010')) {
      api.createRecord('6c6de010', component.options)
    } else {
      api.reload('6c6de010', component.options)
    }
    module.hot.accept("./ExpandTransition.vue?vue&type=template&id=6c6de010&scoped=true", function () {
      api.rerender('6c6de010', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Transitions/ExpandTransition.vue"
export default component.exports